<template>
  <section>
    <SharedPageHeaderTitle :title="t('pages.features.bot.title')" />

    <div class="base-container-first bot__wrapper">
      <ul class="bot__cards">
        <li
          v-for="(card, cardIndex) in CARDS"
          :key="cardIndex"
        >
          <SharedPageCard
            isWhite
            :card
          />
        </li>
      </ul>

      <SharedPageBusiness :business-list="BUSINESSES" />

      <ul class="bot__cards">
        <li
          v-for="(setting, settingIndex) in SETTINGS"
          :key="settingIndex"
        >
          <SharedPageCard
            isWhite
            :card="setting"
          />
        </li>
      </ul>
    </div>
  </section>

  <ContactOrderForm
    :description="t('pages.features.bot.managerDescription')"
    :title="t('pages.features.bot.questionsTitle')"
  />
</template>

<script setup lang="ts">
const { t, locale } = useI18n();

const CARDS = computed(() => [
  {
    description: t("pages.features.bot.cards.easyConnection.description"),
    image: "bot-card-1",
    title: t("pages.features.bot.cards.easyConnection.title"),
  },
  {
    description: t("pages.features.bot.cards.notifications.description"),
    image: "bot-card-2",
    title: t("pages.features.bot.cards.notifications.title"),
  },
]);

const BUSINESSES = computed(() => [
  t("pages.features.bot.businesses.beautySalon"),
  t("pages.features.bot.businesses.clothingStore"),
  t("pages.features.bot.businesses.lawyer"),
  t("pages.features.bot.businesses.barbershop"),
  t("pages.features.bot.businesses.carWash"),
  t("pages.features.bot.businesses.fitness"),
  t("pages.features.bot.businesses.notary"),
  t("pages.features.bot.businesses.photoStudio"),
  t("pages.features.bot.businesses.billiardRoom"),
  t("pages.features.bot.businesses.yourBusiness"),
]);

const SETTINGS = computed(() => [
  {
    description: t("pages.features.bot.settings.answers.description"),
    image: "bot-card-3",
    title: t("pages.features.bot.settings.answers.title"),
  },
  {
    description: t("pages.features.bot.settings.commands.description"),
    image: "bot-card-4",
    title: t("pages.features.bot.settings.commands.title"),
  },
]);

useSeoMeta({
  title: t("pages.features.bot.title"),
});
</script>

<style scoped>
.bot__wrapper {
  display: flex;
  flex-direction: column;
  row-gap: 80px;
  margin: 0 auto 80px;
  padding: 0 24px;
}

@media (--desktop) {
  .bot__wrapper {
    row-gap: 120px;
    margin-bottom: 120px;
  }
}

.bot__cards {
  display: grid;
  row-gap: 16px;
}

@media (--desktop) {
  .bot__cards {
    grid-template-columns: repeat(2, 1fr);
    column-gap: 20px;
  }
}
</style>
